import type {OnboardingChecklistKey} from 'nutshell-graphql-types';
import type {OnboardingChecklistItem} from 'nutshell-graphql-types';

import {analyticsClient} from '../../../analytics-client';
import {appHistory} from '../../../history';

import {useGetSessionUser} from '../../core/use-get-session-user';
import type {CueCard} from '../../glossary/consts/cue-card-collection';

import {CUE_CARDS} from './sidebar-consts';

export const getOnClickForOnboardingChecklistItem = (input: {
    key: OnboardingChecklistKey;
    openInviteModal?: () => void;
    openImportModal?: () => void;
    openAnalyticsModal?: () => void;
    closeSidebar?: () => void;
}) => {
    const {key, openInviteModal, openImportModal, openAnalyticsModal, closeSidebar} = input;

    switch (key) {
        case 'inviteYourTeam':
            return () => {
                analyticsClient.track(
                    analyticsClient.EVENTS.TRACK_ONBOARDING_CHECKLIST_INVITE_YOUR_TEAM_CLICKED
                );

                openInviteModal?.();
            };
        case 'connectExternalAccount':
            return () => {
                analyticsClient.track(
                    analyticsClient.EVENTS.TRACK_ONBOARDING_CHECKLIST_CONNECT_ACCOUNT
                );

                appHistory.push({
                    pathname: window.location.pathname,
                    search: window.location.search,
                    hash: '#/connect-email/get-started',
                });
            };
        case 'importContacts':
            return () => {
                analyticsClient.track(
                    analyticsClient.EVENTS.TRACK_ONBOARDING_CHECKLIST_IMPORT_CONTACTS_CLICKED
                );

                if (closeSidebar) {
                    closeSidebar();
                }

                openImportModal?.();
            };
        case 'createBroadcast':
            return () => {
                analyticsClient.track(
                    analyticsClient.EVENTS.TRACK_ONBOARDING_CHECKLIST_CREATE_BROADCAST_CLICKED
                );

                appHistory.push('/email-marketing/broadcasts');
            };
        case 'createForm':
            return () => {
                analyticsClient.track(
                    analyticsClient.EVENTS.TRACK_ONBOARDING_CHECKLIST_CREATE_FORM_CLICKED
                );

                appHistory.push('/email-marketing/forms');
            };
        case 'useAnalytics':
            return () => {
                analyticsClient.track(
                    analyticsClient.EVENTS.TRACK_ONBOARDING_CHECKLIST_USE_ANALYTICS_CLICKED
                );

                openAnalyticsModal?.();
            };
    }
};

// Loosely typed return to make flow happy
export const getOnboardingChecklistItems = (input: {
    items: OnboardingChecklistItem[];
    openInviteModal?: () => void;
    openImportModal?: () => void;
    openAnalyticsModal?: () => void;
    closeSidebar?: () => void;
}): any[] => {
    const {items, openInviteModal, openImportModal, openAnalyticsModal, closeSidebar} = input;

    return items.map((item) => ({
        ...item,
        onClick: getOnClickForOnboardingChecklistItem({
            key: item.key,
            openInviteModal,
            openImportModal,
            openAnalyticsModal,
            closeSidebar,
        }),
    }));
};

export const useGetCueCardsForOnboardingSidebar = (): CueCard[] => {
    const {user} = useGetSessionUser();
    const completedWizards = user ? user.completedWizards : [];

    return CUE_CARDS.filter((card) => !completedWizards.includes(card.settingsKey)).filter(
        (card) => !card.adminOnly || (user && user.isAdministrator)
    );
};
